import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AppGlobals } from '../../app.globals';
import { currentBrand } from '../../helpers/tenant-switch';

@Component({
    selector: 'app-login',
    templateUrl: './app-login.component.html',
    styleUrls: ['./app-login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLoginComponent implements OnInit {
  @Output() userLoggedIn: EventEmitter<any> = new EventEmitter<any>();
  @Output() loginRedirect: EventEmitter<any> = new EventEmitter<any>();
  @Output() logout: EventEmitter<any> = new EventEmitter<any>();

  loginFormVisible: boolean = true;

  environmentName: string;
  logoUrl: string;

  constructor(public appGlobals: AppGlobals) {}

  ngOnInit(): void {
    document.body.className = 'dx-viewport body-public';
    this.environmentName = AppGlobals.EnvironmentName;

    const brand = currentBrand();
    this.logoUrl = `/assets/images/branding/${brand}/logo.png`;

    AppGlobals.BaseUrl = brand;
  }

  attemptLogin(): void {
    this.loginRedirect.emit();
  }
}
